<template>
  <b-modal
    v-model="showModal"
    id="collectPaymentModal"
    modal-class="collect-payment-modal"
    centered
    hide-footer
    title="Collect Payment"
  >
    <!-- <p class="payment-type-label">Gratuity</p>

    <b-row class="payment-type-buttons">
      <b-col cols="8" class="payment-type-button">
        <b-btn
          class="payment-type-button"
          variant="secondary"
          @click="showTipPaymentModal"
        >
          Pass to Customer
        </b-btn>
      </b-col>
    </b-row> -->

    <!-- <p class="payment-type-label">Card</p>

    <b-row class="payment-type-buttons">
      <b-col cols="4">
        <b-btn
          class="payment-type-button"
          variant="secondary"
          :disabled="getReaderConnectionStatus !== 'connected'"
          @click="showEnterPaymentModal(paymentMethods.TERMINAL)"
        >
          Terminal
        </b-btn>
      </b-col>

      <b-col cols="4">
        <b-btn
          class="payment-type-button"
          variant="secondary"
          :disabled="!stripeConnected"
          @click="showEnterPaymentModal(paymentMethods.STRIPE)"
        >
          Stripe
        </b-btn>
      </b-col>

      <b-col cols="4">
        <b-btn
          class="payment-type-button"
          variant="secondary"
          disabled
          @click="showEnterPaymentModal(null)"
        >
          Other
        </b-btn>
      </b-col>

      <b-col cols="8">
        <b-btn
          v-if="allowCardReader"
          class="payment-type-button mt-3"
          variant="secondary"
          @click="showEnterPaymentModal(paymentMethods.CARD_READER)"
        >
          USB Card Reader
        </b-btn>
      </b-col>
    </b-row> -->

    <p class="payment-type-label">Cash</p>

    <b-row class="payment-type-buttons">
      <b-col cols="4">
        <b-btn
          class="payment-type-button"
          variant="secondary"
          @click="showEnterPaymentModal(paymentMethods.MANUAL, false)"
        >
          {{ tab && tab.stats ? formatMoney(tab.stats.balance_due) : 0 }}
        </b-btn>
      </b-col>

      <b-col cols="4">
        <b-btn
          class="payment-type-button"
          variant="secondary"
          @click="showEnterPaymentModal(paymentMethods.MANUAL)"
        >
          Custom Amount
        </b-btn>
      </b-col>
    </b-row>

    <p class="payment-type-label">Payment</p>

    <b-row class="payment-type-buttons">
      <b-col cols="4">
        <b-btn
          class="payment-type-button"
          variant="secondary"
          @click="showEnterPaymentModal(paymentMethods.OTHER)"
        >
          Add Payment
        </b-btn>
      </b-col>
    </b-row>

    <p class="payment-type-label">Adjustments</p>

    <b-row class="payment-type-buttons">
      <b-col cols="4">
        <b-btn
          class="payment-type-button"
          variant="secondary"
          @click="showEnterAdjustmentModal(adjustmentTypes.DISCOUNT)"
        >
          Discount
        </b-btn>
      </b-col>

      <b-col cols="4">
        <b-btn
          class="payment-type-button"
          variant="secondary"
          @click="showEnterAdjustmentModal(adjustmentTypes.REFUND)"
        >
          Refund
        </b-btn>
      </b-col>
    </b-row>

    <enter-payment-modal
      ref="enterPaymentModal"
      :payer="payer"
      @submit="onSubmitPayment"
    />

    <tip-payment-modal
      ref="tipPaymentModal"
      :payer="payer"
      :tab="tab"
      @submit="onSubmitGratuity"
    />

    <enter-adjustment-modal
      ref="enterAdjustmentModal"
      @submit="onSubmitAdjustment"
    />

    <div v-if="loading" class="payment-spinner">
      <spinner-loader />
    </div>
  </b-modal>
</template>

<script>
import { mapGetters, mapState } from "vuex";
import {
  PAYMENT_TYPES,
  PAYMENT_METHODS,
  ADJUSTMENT_TYPES,
} from "@/config/constants";
import { formatMoney } from "@/utils/number-utils";

export default {
  name: "CollectPaymentModal",

  props: {
    payer: {
      type: String,
      default: "Hotel",
    },

    tab: {
      type: Object,
      default: () => {},
    },

    loading: {
      type: Boolean,
      default: false,
    },
  },

  components: {
    EnterAdjustmentModal: () =>
      import("@/components/modals/EnterAdjustmentModal"),
    EnterPaymentModal: () => import("./EnterPaymentModal"),
    TipPaymentModal: () => import("./TipPaymentModal"),
    SpinnerLoader: () => import("@/components/widgets/SpinnerLoader"),
  },

  data() {
    return {
      showModal: null,
      adjustmentTypes: ADJUSTMENT_TYPES,
      paymentMethods: PAYMENT_METHODS,
      allowCardReader: true,
    };
  },

  computed: {
    ...mapGetters([
      "getVendor",
      "getCurrentReader",
      "getAvailableModifiers",
      "getReaderConnectionStatus",
    ]),

    ...mapState({
      stripeConnected: (state) => !!state.vendor.vendor.stripe_id,
    }),
  },

  methods: {
    formatMoney(value) {
      return formatMoney(value, 2, this.getVendor.local_currency);
    },

    show() {
      this.showModal = true;
    },

    hide() {
      this.showModal = false;
    },

    onSubmitPayment(paymentData) {
      this.$emit("submit-payment", paymentData);
    },

    onSubmitGratuity(amount) {
      let modifier = this.getAvailableModifiers.find(
        (modifier_) => modifier_.category_id === ADJUSTMENT_TYPES.GRATUITY
      );

      const modifierData = {
        modifier_id: modifier.id,
        rate: amount,
        description: modifier.name,
        name: modifier.name,
      };

      this.$emit("submit-adjustment", modifierData);
    },

    onSubmitAdjustment(category_id, amount) {
      let modifier = this.getAvailableModifiers.find(
        (modifier_) => modifier_.category_id === category_id
      );

      const modifierData = {
        modifier_id: modifier.id,
        rate: amount,
        description: modifier.name,
        name: modifier.name,
      };

      this.$emit("submit-adjustment", modifierData);
    },

    setAllowCardReader(value = true) {
      this.allowCardReader = value;
    },

    showEnterPaymentModal(paymentMethod, allowPartial = true) {
      this.$refs.enterPaymentModal.show(allowPartial);

      this.$refs.enterPaymentModal.setAmount(this.tab.stats.balance_due);
      this.$refs.enterPaymentModal.setPaymentType(PAYMENT_TYPES.PAYMENT);
      this.$refs.enterPaymentModal.setPaymentMethod(paymentMethod);
    },

    showTipPaymentModal() {
      this.$refs.tipPaymentModal.show();
    },

    showEnterAdjustmentModal(adjustmentType) {
      let modifier = this.getAvailableModifiers.find(
        (modifier_) => modifier_.category_id === adjustmentType
      );

      this.$refs.enterAdjustmentModal.show(modifier);
    },
  },
};
</script>

<style lang="scss">
.collect-payment-modal {
  .modal-body {
    padding: 0px 30px 30px 30px;
    position: static;
  }

  .payment-type-label {
    font-size: 18px;
    margin-top: 15px;
    margin-bottom: 10px;
    text-align: left;
  }

  .payment-type-buttons {
    & > div {
      text-align: left;
    }

    .btn {
      width: 100%;
    }
  }

  .payment-spinner {
    background-color: rgba(0, 0, 0, 0.125);
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
  }
}
</style>
